import { assert } from '@ember/debug';
import { captureException } from '@sentry/ember';
import { TranslationType, RestaurantsTranslationType } from '@square/dashboard-data/models/squareup/beemo/translation-types/name-or-translation-type';

// Overrides `common.translationTypes.*` so that we can have vertical specific translations.
// Currently the key dependencies are:
//  - userRailsPermissions.canSeeBasicRestaurantsFeatures
export function getTranslationTypeTranslation({
  translationType = '',
  userRailsPermissions
}, intl, intlCountry) {
  assert('userRailsPermissions is required', userRailsPermissions);
  const isRestaurants = userRailsPermissions.canSeeBasicRestaurantsFeatures;
  if (RestaurantsTranslationType.hasValue(translationType) && isRestaurants) {
    // eslint-disable-next-line square/no-translation-key-interpolation
    return intl.t(`restaurants.translationTypes.${translationType}`);
  } else if (TranslationType.hasValue(translationType)) {
    if (translationType === TranslationType.SURCHARGE_AUTO_GRATUITY) {
      return intlCountry.t(`common.translationTypes.${translationType}`);
    } else {
      // eslint-disable-next-line square/no-translation-key-interpolation
      return intl.t(`common.translationTypes.${translationType}`);
    }
  } else {
    captureException(new Error(`Unknown Beemo translation type: ${translationType}`));
    return translationType;
  }
}